<template>
  <div class="h-100 p-3">
    <canvas ref="chart"></canvas>
  </div>
</template>

<script>
import { Chart, registerables } from 'chart.js';
import { IGNORED_WORDS } from '@/organisation/constants';
import { COLOR_SCHEMES } from '@/common/utils/constants';

export default {
  name: 'ItemDataTop10Words',
  props: {
    answers: {
      type: Array,
      required: true,
    },
  },
  computed: {
    top10Words() {
      const countsObject = {};
      const words = this.answers.map((answer) => (answer.value_cleaned || answer.value_str))
        .join(' ')
        .toLowerCase()
        .replace(/[^a-zA-Z0-9 ]/g, '')
        .match(/\S+\s*/g)
        .map((word) => (word.replace(' ', '')))
        .filter((word) => (!IGNORED_WORDS.includes(word)));

      words.forEach((word) => {
        if (countsObject[word]) {
          countsObject[word] += 1;
        } else {
          countsObject[word] = 1;
        }
      });
      return Object.entries(countsObject)
        .sort((a, b) => b[1] - a[1])
        .slice(0, 10);
    },
  },
  mounted() {
    const words = this.top10Words;
    Chart.register(...registerables);
    // eslint-disable-next-line no-new
    new Chart(
      this.$refs.chart.getContext('2d'),
      {
        type: 'bar',
        data: {
          labels: words.map((word) => (word[0])),
          datasets: [{
            label: '# of Votes',
            data: words.map((word) => (word[1])),
            backgroundColor: COLOR_SCHEMES.red,
            borderColor: COLOR_SCHEMES.red,
            borderWidth: 1,
          }],
        },
        options: {
          plugins: {
            legend: {
              display: false,
            },
          },
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            y: {
              beginAtZero: true,
            },
          },
        },
      },
    );
  },
};
</script>
